import type { LucideIcon } from 'lucide-react'

export interface EmptyStateProps {
  icon: LucideIcon
  headline: string
  description: string
  action?: {
    label: string
    onClick: () => void
  }
}

// Icon + headline + one sentence + primary action - every screen's empty state.
export function EmptyState({ icon: Icon, headline, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-control border border-border bg-surface p-8 text-center">
      <Icon size={20} strokeWidth={1.5} className="text-text-secondary" />
      <div className="text-header font-semibold text-text-primary">{headline}</div>
      <p className="max-w-sm text-body text-text-secondary">{description}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="rounded-control bg-accent px-4 py-2 text-body font-medium text-white"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
